<div *ngIf="loading">
  <div class="loading">
    <span class="text">Loading</span>
    <div _ngcontent-c2="" class="spinner-circle" ng-reflect-klass="spinner-circle" ng-reflect-ng-class="[object Object]"
      ng-reflect-ng-style="[object Object]"
      style="border-color: rgb(148, 232, 196) rgb(148, 232, 196) rgb(148, 232, 196) rgb(40, 183, 121);"></div>
  </div>
</div>
<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div id="main-wrapper" #MainWrapper [attr.data-sidebartype]="matcher.matches ? 'full' : 'mini-sidebar'">
  <!-- ============================================================== -->
  <!-- Topbar header - style you can find in pages.scss -->
  <!-- ============================================================== -->
  <header class="topbar" data-navbarbg="skin5">
    <nav class="navbar top-navbar navbar-expand-md navbar-dark">
      <div class="navbar-header" data-logobg="skin5">
        <!-- This is for the sidebar toggle which is visible on mobile only -->
        <a class="nav-toggler waves-effect waves-light d-block d-md-none" href="javascript:void(0)"
          (click)="MenuHandle()"><i class="ti-menu ti-close"></i></a>
        <!-- ============================================================== -->
        <!-- Logo -->
        <!-- ============================================================== -->
        <a class="navbar-brand" href="Auth">
          <!-- Logo icon -->
          <b class="logo-icon p-l-10">

          </b>
          <!--End Logo icon -->
          <!-- Logo text -->
          <span class="logo-text">
            <!-- dark Logo text -->
            GSS Auth - HQ Instance

          </span>
          <!-- Logo icon -->
          <!--You can put here icon as well -->
          <!-- Dark Logo icon -->
          <!--End Logo icon -->
        </a>
        <!-- ============================================================== -->
        <!-- End Logo -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->
        <!-- Toggle which is visible on mobile only -->
        <!-- ============================================================== -->
        <a class="topbartoggler d-block d-md-none waves-effect waves-light" href="javascript:void(0)"
          data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
          aria-expanded="false" aria-label="Toggle navigation" (click)="MiniUserHandle()"><i class="ti-more"></i></a>
      </div>
      <!-- ============================================================== -->
      <!-- End Logo -->
      <!-- ============================================================== -->
      <div class="navbar-collapse collapse" id="navbarSupportedContent" #SupportedContent data-navbarbg="skin5">
        <!-- ============================================================== -->
        <!-- toggle and nav items -->
        <!-- ============================================================== -->
        <ul class="navbar-nav float-left mr-auto">
          <li class="nav-item d-none d-md-block"><a class="nav-link sidebartoggler waves-effect waves-light"
              href="javascript:void(0)" data-sidebartype="mini-sidebar" (click)="MenuHandle()"><i
                class="mdi mdi-menu font-24"></i></a></li>
        </ul>
        <!-- ============================================================== -->
        <!-- Right side toggle and nav items -->
        <!-- ============================================================== -->
        <ul class="navbar-nav float-right">
          <!-- ============================================================== -->
          <!-- Messages -->
          <!-- ============================================================== -->
          <li class="nav-item dropdown" *ngIf='false' #MessageIcon>
            <a class="nav-link dropdown-toggle waves-effect waves-dark" href="" id="2" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false"> <i class="font-24 mdi mdi-comment-processing"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-right mailbox animated bounceInDown" aria-labelledby="2">
              <ul class="list-style-none">
                <li>
                  <div class="">
                    <!-- Message -->
                    <a href="javascript:void(0)" class="link border-top">
                      <div class="d-flex no-block align-items-center p-10">
                        <span class="btn btn-success btn-circle"><i class="ti-calendar"></i></span>
                        <div class="m-l-10">
                          <h5 class="m-b-0">Event today</h5>
                          <span class="mail-desc">Just a reminder that event</span>
                        </div>
                      </div>
                    </a>
                    <!-- Message -->
                    <a href="javascript:void(0)" class="link border-top">
                      <div class="d-flex no-block align-items-center p-10">
                        <span class="btn btn-info btn-circle"><i class="ti-settings"></i></span>
                        <div class="m-l-10">
                          <h5 class="m-b-0">Settings</h5>
                          <span class="mail-desc">You can customize this template</span>
                        </div>
                      </div>
                    </a>
                    <!-- Message -->
                    <a href="javascript:void(0)" class="link border-top">
                      <div class="d-flex no-block align-items-center p-10">
                        <span class="btn btn-primary btn-circle"><i class="ti-user"></i></span>
                        <div class="m-l-10">
                          <h5 class="m-b-0">Pavan kumar</h5>
                          <span class="mail-desc">Just see the my admin!</span>
                        </div>
                      </div>
                    </a>
                    <!-- Message -->
                    <a href="javascript:void(0)" class="link border-top">
                      <div class="d-flex no-block align-items-center p-10">
                        <span class="btn btn-danger btn-circle"><i class="fa fa-link"></i></span>
                        <div class="m-l-10">
                          <h5 class="m-b-0">Luanch Admin</h5>
                          <span class="mail-desc">Just see the my new admin!</span>
                        </div>
                      </div>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </li>
          <!-- ============================================================== -->
          <!-- End Messages -->
          <!-- ============================================================== -->

          <!-- ============================================================== -->
          <!-- User profile and search -->
          <!-- ============================================================== -->
          <li class="nav-item dropdown" id="li-user" (click)="UserHandle()" #UserIcon>
            <a class="nav-link dropdown-toggle text-muted waves-effect waves-dark pro-pic" href="javascript:void(0)"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <img src="https://portal.gss.hq.intra.acer.com:7083/images/users/1.jpg" alt="user" class="rounded-circle"
                width="31">
              <span class="user-head-text">{{currentUser.UserName}}</span>
            </a>
            <div class="dropdown-menu dropdown-menu-right user-dd animated">
              <a class="dropdown-item" href="javascript:void(0)" (click)="MyProfile()"><i
                  class="ti-user m-r-5 m-l-5"></i> My Profile</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="javascript:void(0)" (click)="Logout()"><i
                  class="fa fa-power-off m-r-5 m-l-5"></i> Logout</a>
            </div>
          </li>
          <!-- ============================================================== -->
          <!-- User profile and search -->
          <!-- ============================================================== -->
        </ul>
      </div>
    </nav>
  </header>
  <!-- ============================================================== -->
  <!-- End Topbar header -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
  <app-sidebar (CurrentPath)="onChangeParentPath($event)"></app-sidebar>
  <!-- ============================================================== -->
  <!-- End Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- Page wrapper  -->
  <!-- ============================================================== -->
  <div class="page-wrapper">
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <app-breadcrumb [parent]=ParentPath (CurrentPath)="ParentPath"></app-breadcrumb>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container-fluid" id="main-container">
      <router-outlet (activate)='MainContainerActive($event)'></router-outlet>
    </div>
    <!-- ============================================================== -->
    <!-- End Container fluid  -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- footer -->
    <!-- ============================================================== -->
    <footer class="footer text-center">
    </footer>
    <!-- ============================================================== -->
    <!-- End footer -->
    <!-- ============================================================== -->
  </div>
  <!-- ============================================================== -->
  <!-- End Page wrapper  -->
  <!-- ============================================================== -->
</div>
<!-- ============================================================== -->
<!-- End Wrapper -->
